import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',{staticClass:"row"},[_c(VCol,{staticClass:"d-flex justify-start",attrs:{"cols":"2"}},[_c('h1',[_vm._v("VisitaImoveis360º")])]),_c(VCol,{staticClass:"align-center black--text mt-4"}),_c(VCol,{staticClass:"d-flex justify-end",attrs:{"cols":"2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }